import axios from "axios";
import { useEffect, useState } from "react";

const API = "https://stu168523.webhosting.arden.ac.uk";

export default function AdminDashboard() {
  const [categories, setCategories] = useState([]);

  const loadCategories = async () => {
    const res = await axios.get(API + "/api/categories");
    setCategories(res.data);
  };

  useEffect(() => {
    loadCategories();
  }, []);

  return (
    <div>
      <h1>Admin Dashboard</h1>
      <ul>
        {categories.map((c) => (
          <li key={c._id}>{c.name}</li>
        ))}
      </ul>
    </div>
  );
}
